import { Component, OnInit} from '@angular/core';
import { SubmissionSearchObject, SubmissionSearchUserInfoObject } from '../search-object';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {DateUtil} from '../date-util';
import * as _moment from 'moment';
import {PaginationObject} from '../pagination-object';

const moment = _moment;

@Component({
    selector: 'submission-search',
    templateUrl: './submission-search.component.html',
    styleUrls: [ './submission-search.component.scss' ],
    providers: [
      {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
      {provide: MAT_DATE_FORMATS, useValue: DateUtil.MY_FORMATS}
      ]
})
export class SubmissionSearchComponent implements OnInit {

    date = new FormControl(moment());
    minDate = new Date(2000, 0, 1);
    maxDate = new Date();
    searchCriteria = new SubmissionSearchObject();
    userSearchInfo = new SubmissionSearchUserInfoObject();
    pagination: PaginationObject = new PaginationObject();

    ngOnInit() {
        this.submissionHistoryService.currentUserInfo.subscribe(message => this.userSearchInfo = message);
        this.submissionHistoryService.currentPagination.subscribe(message => this.pagination = message);
        this.submissionHistoryService.currentSearchCriteria.subscribe(message => this.searchCriteria = message);
    }

    constructor(private submissionHistoryService: SubmissionHistoryService) {
        this.searchCriteria.submissionIdentifierType = 'fileId';
    }

    onSubmit() {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;

        if (DateUtil.validateDateTime(startDate.value) && DateUtil.validateDateTime(endDate.value)) {
            this.updateTableDataSearch(this.searchCriteria);
            this.getTotalCountSearch(this.searchCriteria);
        } else {
            return;
        }
    }

    public updateTableDataSearch(search: SubmissionSearchObject): void {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;
        const startTime = document.querySelector('#startTime') as HTMLInputElement;
        const endTime = document.querySelector('#endTime') as HTMLInputElement;

        const startDateTime = startDate.value + ' ' + startTime.value;
        const endDateTime = endDate.value + ' ' + endTime.value;
        this.pagination.currentPage = 0;
        this.submissionHistoryService.changePagination(this.pagination);
        this.submissionHistoryService.getSearchTableContent(search, startDateTime.trim(), endDateTime.trim(), 0);
        document.querySelector('#dashboardScrollPane').scrollTop = 0;
    }

    public getTotalCountSearch(search: SubmissionSearchObject): void {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;
        const startTime = document.querySelector('#startTime') as HTMLInputElement;
        const endTime = document.querySelector('#endTime') as HTMLInputElement;

        const startDateTime = startDate.value + ' ' + startTime.value;
        const endDateTime = endDate.value + ' ' + endTime.value;
        this.submissionHistoryService.getSearchTableContentCount(search, startDateTime.trim(), endDateTime.trim());
    }

    clear() {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;
        const startTime = document.querySelector('#startTime') as HTMLInputElement;
        const endTime = document.querySelector('#endTime') as HTMLInputElement;

        startDate.value = ''
        endDate.value = ''
        startTime.value = ''
        endTime.value = ''

        this.searchCriteria = new SubmissionSearchObject();
        this.searchCriteria.submissionIdentifierType = 'fileId';
    }

    public onStartDateChange(searchValue: string) {
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            document.querySelector( '#startDateFormField' ).classList.remove( 'mat-form-field-invalid' )
        } else {
            document.querySelector( '#startDateFormField' ).classList.add( 'mat-form-field-invalid' )
        }
    }


    public onEndDateChange(searchValue: string) {
        console.log(searchValue);
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            document.querySelector( '#endDateFormField' ).classList.remove( 'mat-form-field-invalid' )
        } else {
            document.querySelector( '#endDateFormField' ).classList.add( 'mat-form-field-invalid' )
        }
    }

    public onStartDateSelected() {
        document.querySelector( '#startDateFormField' ).classList.remove( 'mat-form-field-invalid' )
    }

    public onEndDateSelected() {
        document.querySelector( '#endDateFormField' ).classList.remove( 'mat-form-field-invalid' )
    }

    public getTestTypeDisplayName(item: any): string {
        const name = typeof item === 'string' ? item : (item?.name || item);
        if (name === 'Blood Group Antigens') {
            return 'BGA';
        }
        return name;
    }
}
